"use client";

import {useEffect, useState} from "react";

import OverviewModal from "@/components/health-and-retirement-studies/overview/overview-modal/overview-modal";
import {Button, Modal, Table} from "react-bootstrap";

type SurveyOverviewProps = {
  study: {id: number; title: string; full_name: string; has_overview: boolean};
  countries: string;
  years_collected: number;
  study_type: string;
  rounds: string;
  covid_full_name: string;
};

type OverviewTableProps = {
  overviews: SurveyOverviewProps[];
  initialStudyId?: number;
};

export default function OverviewTable({
  overviews,
  initialStudyId,
}: OverviewTableProps) {
  const [showModal, setShowModal] = useState(false);
  const [studyId, setStudyId] = useState<number>();
  const [studyTitle, setStudyTitle] = useState<string>();

  useEffect(() => {
    if (initialStudyId) {
      const found = overviews.find((o) => o.study.id === initialStudyId);
      if (found) {
        setStudyId(found.study.id);
        setStudyTitle(found.study.title);
        setShowModal(true);
      }
    }
  }, [initialStudyId, overviews]);

  const handleStudyClick = (id: number, title: string) => {
    setStudyId(id);
    setStudyTitle(title);
    setShowModal(true);
  };

  return (
    <>
      <Table striped responsive>
        <thead>
          <tr className='g2-table-header-blue'>
            <th>Studies</th>
            <th>Full Name</th>
            <th>Countries</th>
            <th>Year Collected</th>
            <th>Type</th>
            <th>Rounds</th>
          </tr>
        </thead>
        <tbody>
          {overviews.map((row) => (
            <tr key={row.study.id} className='align-middle'>
              {row.study.has_overview ? (
                <td
                  className='g2-link-blue fw-bold'
                  onClick={() =>
                    handleStudyClick(row.study.id, row.study.title)
                  }
                  style={{cursor: "pointer"}}
                >
                  {row.study.title}
                </td>
              ) : (
                <td className='fw-bold'>{row.study.title}</td>
              )}
              <td>{row.covid_full_name}</td>
              <td>{row.countries}</td>
              <td>{row.years_collected}</td>
              <td>{row.study_type}</td>
              <td>{row.rounds}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size='xl'
        aria-labelledby='srv-overview-modal'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className='g2-text-grey'>{studyTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {studyId !== undefined && <OverviewModal studyId={studyId} />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
